<div class="container main-font">
  <div class="w-100 b-bottom page-header mb-2">
    <p class="fs-3 ps-3 mb-0">Storico team passati</p>
  </div>
  <div class="row mx-3 pt-1 g-4 justify-content-between">
    <!-- <div class="container"> -->

    <div class="col-4">
      <button
        mat-raised-button
        class="main-font"
        routerLink="/secure/dashboard/i-miei-team">
        I miei team
      </button>
    </div>
    <!-- select per selezionare l'anno -->
    <div class="col-8">
      <div class="nav nav-pills nav-fill col-4">
        <div role="button" class="nav-item text-wrap">
          <div class="">
            <button
              class="btn nav-link nav-link-active border b-top p-1"
              type="button"
              [value]="this.selectedYear"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ this.selectedYear }}
            </button>
            <ul class="dropdown-menu">
              <li
                *ngFor="let year of years; index as i"
                (click)="selectYears(year.value)">
                <a class="dropdown-item">{{ year.value }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="d-flex justify-content-between mb-2"> -->

    <!-- bottone per aprire e chiudere tutti gli accordion -->
    <!-- <button mat-raised-button class="main-font" (click)="change(tabProjects)">{{ this.expandedProjects || this.expandedCourses === true ? 'Chiudi tutto' : 'Espandi tutto' }}</button> -->

    <!-- </div> -->

    <mat-tab-group class="mt-1">
      <mat-tab label="Progetti">
        <div class="projects-wrapper py-4">
          <!-- NUOVE CARD -->
          <div
            *ngFor="let result of teamsProjects; let i = index"
            class="project-container"
            #card>
            <mat-card class="project-card">
              <mat-card-header
                class="main-font justify-content-between primary-color-light">
                <mat-card-title-group
                  class="d-flex align-items-center justify-content-start">
                  <label class="image-container col-1 me-2">
                    <img
                      [src]="
                        utilityService.getSanitizeUrl(result.filestorage.path)
                      "
                      alt="project image"
                      class="logo imageLogo mt-3 rounded-circle" />
                  </label>
                  <div>
                    <h3 class="m-0">{{ result?.alias }}</h3>
                    <span class="small fw-light text-secondary">
                      Dal {{ result?.startproject_date | date: 'dd/MM/yyyy' }}
                      {{
                        result?.endproject_date != null
                          ? 'al ' +
                            (result?.endproject_date | date: 'dd/MM/yyyy')
                          : '- Presente &nbsp; &nbsp;'
                      }}
                    </span>
                  </div>
                </mat-card-title-group>

                <mat-card-actions class="justify-content-end">
                  <!-- <button mat-raised-button color="accent" class="me-2" (click)="toggleFlip(card, result.id)" [disabled]="!result.statistical.Numbers">{{ card.classList.contains('flipped') ? 'Team' : 'Statistiche' }}</button> -->
                  <!-- <button mat-raised-button color="accent" routerLink="bacheca" (click)="goToScrum(result)">Scrum</button> -->
                </mat-card-actions>
              </mat-card-header>

              <mat-card-content class="scroll scrollbar pt-3 card-inner">
                <div class="front-face col-12">
                  <div
                    *ngIf="
                      teamsProjects[i].project_user.length != 0;
                      else sadGif
                    ">
                    <app-card-membro-team
                      (getProfile)="getElement($event)"
                      [data]="result.project_user">
                    </app-card-membro-team>
                  </div>
                </div>

                <div class="back-face col-12 align-items-center">
                  <div
                    [id]="'graphCarousel' + result.id"
                    class="carousel slide">
                    <div class="carousel-indicators">
                      <button
                        type="button"
                        [attr.data-bs-target]="'#graphCarousel' + result.id"
                        data-bs-slide-to="0"
                        class="indicator active"
                        aria-current="true"
                        aria-label="Contatori"></button>
                      <button
                        type="button"
                        [attr.data-bs-target]="'#graphCarousel' + result.id"
                        data-bs-slide-to="1"
                        class="indicator"
                        aria-label="Velocity"></button>
                      <button
                        type="button"
                        [attr.data-bs-target]="'#graphCarousel' + result.id"
                        data-bs-slide-to="2"
                        class="indicator"
                        aria-label="Capacity"></button>
                    </div>
                    <div class="carousel-inner">
                      <div class="carousel-item active">
                        <div class="row g-4" *ngIf="result.statistical.Numbers">
                          <div class="col-4">
                            <button
                              class="scrum-btn w-100"
                              type="button"
                              data-bs-toggle="dropdown">
                              Da sprint
                              {{ result.statistical.start_sprint_number }}
                              <svg
                                class="button-svg"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24">
                                <path d="M7 10l5 5 5-5z" />
                              </svg>
                            </button>
                            <ul class="dropdown-menu">
                              <li
                                *ngFor="
                                  let sprint of result.statistical.Numbers;
                                  index as i
                                "
                                ngClass="{{
                                  result.statistical.start_sprint_number ==
                                  sprint
                                    ? 'selected-li'
                                    : result.statistical.end_sprint_number
                                      ? result.statistical.end_sprint_number >=
                                        sprint
                                        ? 'pointer'
                                        : 'no-pointer'
                                      : 'pointer'
                                }}">
                                <a
                                  class="dropdown-item"
                                  ngClass="{{
                                    result.statistical.end_sprint_number
                                      ? result.statistical.end_sprint_number >=
                                        sprint
                                        ? ''
                                        : 'no-pointer'
                                      : ''
                                  }}"
                                  (click)="
                                    setDate(
                                      result.id,
                                      sprint,
                                      true,
                                      result.statistical.end_sprint_number
                                    )
                                  ">
                                  {{ sprint }}
                                </a>
                              </li>
                            </ul>
                          </div>

                          <div class="col-4">
                            <button
                              class="scrum-btn w-100"
                              type="button"
                              data-bs-toggle="dropdown">
                              A sprint
                              {{ result.statistical.end_sprint_number }}
                              <svg
                                class="button-svg"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24">
                                <path d="M7 10l5 5 5-5z" />
                              </svg>
                            </button>
                            <ul class="dropdown-menu">
                              <li
                                *ngFor="
                                  let sprint of result.statistical.Numbers;
                                  index as i
                                "
                                ngClass="{{
                                  result.statistical.end_sprint_number == sprint
                                    ? 'selected-li'
                                    : result.statistical.start_sprint_number
                                      ? result.statistical
                                          .start_sprint_number <= sprint
                                        ? 'pointer'
                                        : 'no-pointer'
                                      : 'pointer'
                                }}">
                                <a
                                  class="dropdown-item"
                                  ngClass="{{
                                    result.statistical.start_sprint_number
                                      ? result.statistical
                                          .start_sprint_number <= sprint
                                        ? ''
                                        : 'no-pointer'
                                      : ''
                                  }}"
                                  (click)="
                                    setDate(
                                      result.id,
                                      sprint,
                                      false,
                                      result.statistical.start_sprint_number
                                    )
                                  ">
                                  {{ sprint }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div class="row g-4 mt-1">
                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >SP FATTI</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Sp_done }}
                              </mat-card-content>
                            </mat-card>
                          </div>

                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >CAPACITY TOT</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Capacity_tot }}
                              </mat-card-content>
                            </mat-card>
                          </div>

                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >VELOCITY MEDIA</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Velocity_team }}
                              </mat-card-content>
                            </mat-card>
                          </div>

                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >SP SENZA RESIDUO</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Sp_without_residues }}
                              </mat-card-content>
                            </mat-card>
                          </div>

                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >% SP SVILUPPATORE</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Sp_sviluppatore }}
                              </mat-card-content>
                            </mat-card>
                          </div>

                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >VELOCITY CLIENTE</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Velocity_cliente }}
                              </mat-card-content>
                            </mat-card>
                          </div>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <div class="row g-4" *ngIf="result.statistical.Numbers">
                          <div class="col-4">
                            <button
                              class="scrum-btn w-100"
                              type="button"
                              data-bs-toggle="dropdown">
                              Da sprint
                              {{ result.statistical.start_sprint_number }}
                              <svg
                                class="button-svg"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24">
                                <path d="M7 10l5 5 5-5z" />
                              </svg>
                            </button>
                            <ul class="dropdown-menu">
                              <li
                                *ngFor="
                                  let sprint of result.statistical.Numbers;
                                  index as i
                                "
                                ngClass="{{
                                  result.statistical.start_sprint_number ==
                                  sprint
                                    ? 'selected-li'
                                    : result.statistical.end_sprint_number
                                      ? result.statistical.end_sprint_number >=
                                        sprint
                                        ? 'pointer'
                                        : 'no-pointer'
                                      : 'pointer'
                                }}">
                                <a
                                  class="dropdown-item"
                                  ngClass="{{
                                    result.statistical.end_sprint_number
                                      ? result.statistical.end_sprint_number >=
                                        sprint
                                        ? ''
                                        : 'no-pointer'
                                      : ''
                                  }}"
                                  (click)="
                                    setDate(
                                      result.id,
                                      sprint,
                                      true,
                                      result.statistical.end_sprint_number
                                    )
                                  ">
                                  {{ sprint }}
                                </a>
                              </li>
                            </ul>
                          </div>

                          <div class="col-4">
                            <button
                              class="scrum-btn w-100"
                              type="button"
                              data-bs-toggle="dropdown">
                              A sprint
                              {{ result.statistical.end_sprint_number }}
                              <svg
                                class="button-svg"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24">
                                <path d="M7 10l5 5 5-5z" />
                              </svg>
                            </button>
                            <ul class="dropdown-menu">
                              <li
                                *ngFor="
                                  let sprint of result.statistical.Numbers;
                                  index as i
                                "
                                ngClass="{{
                                  result.statistical.end_sprint_number == sprint
                                    ? 'selected-li'
                                    : result.statistical.start_sprint_number
                                      ? result.statistical
                                          .start_sprint_number <= sprint
                                        ? 'pointer'
                                        : 'no-pointer'
                                      : 'pointer'
                                }}">
                                <a
                                  class="dropdown-item"
                                  ngClass="{{
                                    result.statistical.start_sprint_number
                                      ? result.statistical
                                          .start_sprint_number <= sprint
                                        ? ''
                                        : 'no-pointer'
                                      : ''
                                  }}"
                                  (click)="
                                    setDate(
                                      result.id,
                                      sprint,
                                      false,
                                      result.statistical.start_sprint_number
                                    )
                                  ">
                                  {{ sprint }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <!-- <svg class="bd-placeholder-img bd-placeholder-img-lg d-block w-100" width="800" height="400" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: First slide" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#777"></rect><text x="50%" y="50%" fill="#555" dy=".3em">Velocity</text></svg> -->
                        <div class="col-12 mt-5">
                          <canvas id="evolChart"></canvas>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <div class="row g-4" *ngIf="result.statistical.Numbers">
                          <div class="col-4">
                            <button
                              class="scrum-btn w-100"
                              type="button"
                              data-bs-toggle="dropdown">
                              Da sprint
                              {{ result.statistical.start_sprint_number }}
                              <svg
                                class="button-svg"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24">
                                <path d="M7 10l5 5 5-5z" />
                              </svg>
                            </button>
                            <ul class="dropdown-menu">
                              <li
                                *ngFor="
                                  let sprint of result.statistical.Numbers;
                                  index as i
                                "
                                ngClass="{{
                                  result.statistical.start_sprint_number ==
                                  sprint
                                    ? 'selected-li'
                                    : result.statistical.end_sprint_number
                                      ? result.statistical.end_sprint_number >=
                                        sprint
                                        ? 'pointer'
                                        : 'no-pointer'
                                      : 'pointer'
                                }}">
                                <a
                                  class="dropdown-item"
                                  ngClass="{{
                                    result.statistical.end_sprint_number
                                      ? result.statistical.end_sprint_number >=
                                        sprint
                                        ? ''
                                        : 'no-pointer'
                                      : ''
                                  }}"
                                  (click)="
                                    setDate(
                                      result.id,
                                      sprint,
                                      true,
                                      result.statistical.end_sprint_number
                                    )
                                  ">
                                  {{ sprint }}
                                </a>
                              </li>
                            </ul>
                          </div>

                          <div class="col-4">
                            <button
                              class="scrum-btn w-100"
                              type="button"
                              data-bs-toggle="dropdown">
                              A sprint
                              {{ result.statistical.end_sprint_number }}
                              <svg
                                class="button-svg"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24">
                                <path d="M7 10l5 5 5-5z" />
                              </svg>
                            </button>
                            <ul class="dropdown-menu">
                              <li
                                *ngFor="
                                  let sprint of result.statistical.Numbers;
                                  index as i
                                "
                                ngClass="{{
                                  result.statistical.end_sprint_number == sprint
                                    ? 'selected-li'
                                    : result.statistical.start_sprint_number
                                      ? result.statistical
                                          .start_sprint_number <= sprint
                                        ? 'pointer'
                                        : 'no-pointer'
                                      : 'pointer'
                                }}">
                                <a
                                  class="dropdown-item"
                                  ngClass="{{
                                    result.statistical.start_sprint_number
                                      ? result.statistical
                                          .start_sprint_number <= sprint
                                        ? ''
                                        : 'no-pointer'
                                      : ''
                                  }}"
                                  (click)="
                                    setDate(
                                      result.id,
                                      sprint,
                                      false,
                                      result.statistical.start_sprint_number
                                    )
                                  ">
                                  {{ sprint }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <!-- <svg class="bd-placeholder-img bd-placeholder-img-lg d-block w-100" width="800" height="400" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Placeholder: First slide" preserveAspectRatio="xMidYMid slice" focusable="false"><title>Placeholder</title><rect width="100%" height="100%" fill="#777"></rect><text x="50%" y="50%" fill="#555" dy=".3em">Capacity</text></svg> -->
                        <div class="col-12 mt-5">
                          <canvas id="capChart"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Corsi" *ngIf="teamsCourses?.length > 0">
        <div class="projects-wrapper py-4">
          <!-- NUOVE CARD -->
          <div
            *ngFor="let result of teamsCourses; let i = index"
            class="project-container"
            #card>
            <mat-card class="project-card">
              <mat-card-header
                class="main-font justify-content-between primary-color-light">
                <mat-card-title-group
                  class="d-flex align-items-center justify-content-start">
                  <label class="image-container col-1 me-2">
                    <img
                      [src]="
                        utilityService.getSanitizeUrl(result.filestorage.path)
                      "
                      alt="project image"
                      class="logo imageLogo mt-3 rounded-circle" />
                  </label>
                  <div>
                    <h3 class="m-0">{{ result?.alias }}</h3>
                    <span class="small fw-light text-secondary">
                      Dal {{ result?.startproject_date | date: 'dd/MM/yyyy' }}
                      {{
                        result?.endproject_date != null
                          ? 'al ' +
                            (result?.endproject_date | date: 'dd/MM/yyyy')
                          : '- Presente &nbsp; &nbsp;'
                      }}
                    </span>
                  </div>
                </mat-card-title-group>

                <mat-card-actions class="justify-content-end">
                  <!-- <button mat-raised-button color="accent" class="me-2" (click)="toggleFlip(card, result.id)" [disabled]="!result.statistical.Numbers">{{ card.classList.contains('flipped') ? 'Team' : 'Statistiche' }}</button> -->
                  <!-- <button mat-raised-button color="accent" routerLink="bacheca" (click)="goToScrum(result)">Scrum</button> -->
                </mat-card-actions>
              </mat-card-header>

              <mat-card-content class="scroll scrollbar pt-3 card-inner">
                <div class="front-face col-12">
                  <div
                    *ngIf="
                      teamsProjects[i].project_user.length != 0;
                      else sadGif
                    ">
                    <app-card-membro-team
                      (getProfile)="getElement($event)"
                      [data]="result.project_user">
                    </app-card-membro-team>
                  </div>
                </div>

                <div class="back-face col-12 align-items-center">
                  <div
                    [id]="'graphCarousel' + result.id"
                    class="carousel slide">
                    <div class="carousel-indicators">
                      <button
                        type="button"
                        [attr.data-bs-target]="'#graphCarousel' + result.id"
                        data-bs-slide-to="0"
                        class="indicator active"
                        aria-current="true"
                        aria-label="Contatori"></button>
                      <button
                        type="button"
                        [attr.data-bs-target]="'#graphCarousel' + result.id"
                        data-bs-slide-to="1"
                        class="indicator"
                        aria-label="Velocity"></button>
                      <button
                        type="button"
                        [attr.data-bs-target]="'#graphCarousel' + result.id"
                        data-bs-slide-to="2"
                        class="indicator"
                        aria-label="Capacity"></button>
                    </div>
                    <div class="carousel-inner">
                      <div class="carousel-item active">
                        <div class="row g-4" *ngIf="result.statistical.Numbers">
                          <div class="col-4">
                            <button
                              class="scrum-btn w-100"
                              type="button"
                              data-bs-toggle="dropdown">
                              Da sprint
                              {{ result.statistical.start_sprint_number }}
                              <svg
                                class="button-svg"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24">
                                <path d="M7 10l5 5 5-5z" />
                              </svg>
                            </button>
                            <ul class="dropdown-menu">
                              <li
                                *ngFor="
                                  let sprint of result.statistical.Numbers;
                                  index as i
                                "
                                ngClass="{{
                                  result.statistical.start_sprint_number ==
                                  sprint
                                    ? 'selected-li'
                                    : result.statistical.end_sprint_number
                                      ? result.statistical.end_sprint_number >=
                                        sprint
                                        ? 'pointer'
                                        : 'no-pointer'
                                      : 'pointer'
                                }}">
                                <a
                                  class="dropdown-item"
                                  ngClass="{{
                                    result.statistical.end_sprint_number
                                      ? result.statistical.end_sprint_number >=
                                        sprint
                                        ? ''
                                        : 'no-pointer'
                                      : ''
                                  }}"
                                  (click)="
                                    setDate(
                                      result.id,
                                      sprint,
                                      true,
                                      result.statistical.end_sprint_number
                                    )
                                  ">
                                  {{ sprint }}
                                </a>
                              </li>
                            </ul>
                          </div>

                          <div class="col-4">
                            <button
                              class="scrum-btn w-100"
                              type="button"
                              data-bs-toggle="dropdown">
                              A sprint
                              {{
                                result.statistical.end_sprint_number
                                  ? result.statistical.end_sprint_number
                                  : ''
                              }}
                              <svg
                                class="button-svg"
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24">
                                <path d="M7 10l5 5 5-5z" />
                              </svg>
                            </button>
                            <ul class="dropdown-menu">
                              <li
                                *ngFor="
                                  let sprint of result.statistical.Numbers;
                                  index as i
                                "
                                ngClass="{{
                                  result.statistical.end_sprint_number == sprint
                                    ? 'selected-li'
                                    : result.statistical.start_sprint_number
                                      ? result.statistical
                                          .start_sprint_number <= sprint
                                        ? 'pointer'
                                        : 'no-pointer'
                                      : 'pointer'
                                }}">
                                <a
                                  class="dropdown-item"
                                  ngClass="{{
                                    result.statistical.start_sprint_number
                                      ? result.statistical
                                          .start_sprint_number <= sprint
                                        ? ''
                                        : 'no-pointer'
                                      : ''
                                  }}"
                                  (click)="
                                    setDate(
                                      result.id,
                                      sprint,
                                      false,
                                      result.statistical.start_sprint_number
                                    )
                                  ">
                                  {{ sprint }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div class="row g-4 mt-1">
                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >SP FATTI</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Sp_done }}
                              </mat-card-content>
                            </mat-card>
                          </div>

                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >CAPACITY TOT</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Capacity_tot }}
                              </mat-card-content>
                            </mat-card>
                          </div>

                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >VELOCITY MEDIA</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Velocity_team }}
                              </mat-card-content>
                            </mat-card>
                          </div>

                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >SP SENZA RESIDUO</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Sp_without_residues }}
                              </mat-card-content>
                            </mat-card>
                          </div>

                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >% SP SVILUPPATORE</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Sp_sviluppatore }}
                              </mat-card-content>
                            </mat-card>
                          </div>

                          <div class="col-4">
                            <mat-card class="count-card">
                              <mat-card-title class="h5 text-center"
                                >VELOCITY CLIENTE</mat-card-title
                              >
                              <mat-card-content class="h1 text-center">
                                {{ result.statistical.Velocity_cliente }}
                              </mat-card-content>
                            </mat-card>
                          </div>
                        </div>
                      </div>
                      <div class="carousel-item">
                        <svg
                          class="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
                          width="800"
                          height="400"
                          xmlns="http://www.w3.org/2000/svg"
                          role="img"
                          aria-label="Placeholder: First slide"
                          preserveAspectRatio="xMidYMid slice"
                          focusable="false">
                          <title>Placeholder</title>
                          <rect width="100%" height="100%" fill="#777"></rect>
                          <text x="50%" y="50%" fill="#555" dy=".3em">
                            Velocity
                          </text>
                        </svg>
                        <!-- <canvas id="evolChart"></canvas> -->
                      </div>
                      <div class="carousel-item">
                        <svg
                          class="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
                          width="800"
                          height="400"
                          xmlns="http://www.w3.org/2000/svg"
                          role="img"
                          aria-label="Placeholder: First slide"
                          preserveAspectRatio="xMidYMid slice"
                          focusable="false">
                          <title>Placeholder</title>
                          <rect width="100%" height="100%" fill="#777"></rect>
                          <text x="50%" y="50%" fill="#555" dy=".3em">
                            Capacity
                          </text>
                        </svg>
                        <!-- <canvas id="capChart"></canvas> -->
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

    <!-- <mat-tab-group (selectedTabChange)="checkTab($event)" *ngIf="teamsProjects">
      <mat-tab label="Progetti">
          <div class="mt-1">
            <mat-accordion multi>
              <mat-expansion-panel class="mt-2" *ngFor="let result of teamsProjects; let i = index" [expanded]="expandedProjects">
                <mat-expansion-panel-header>
                  <mat-panel-title class="main-font">
                    <label class="image-container">
                      <img [src]="utilityService.getSanitizeUrl(result.filestorage.path)" alt="project image" class="logo imageLogo mt-3 rounded-circle">
                    </label>
                    {{ result?.alias }}
                  </mat-panel-title>
                  <mat-panel-description class="justify-content-end main-font" >
                  <span>Dal {{result?.startproject_date | date: 'dd/MM/yyyy'}}</span>

                  <span> &nbsp;{{result?.endproject_date !=  null ? 'al ' +(result?.endproject_date | date: 'dd/MM/yyyy') : '- Presente &nbsp; &nbsp;'}} </span>

                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="row g-5 justify-content-center mt-3">
                  <ng-container *ngFor="let profile of getProfile(teamsProjects[i].project_user)">
                    <app-card-membro-team class="col-3"
                      [data]="{
                        img: profile.img,
                        fullname: profile.fullname,
                        roles: profile.roles
                      }"
                    >
                    </app-card-membro-team>
                  </ng-container>
                  </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
      </mat-tab>
      <mat-tab label="Corsi" *ngIf="teamsCourses">
          <div class="margin-tab">
            <mat-accordion multi>
              <mat-expansion-panel class="mt-2" *ngFor="let result of teamsCourses; let i = index" [expanded]="expandedCourses">
                <mat-expansion-panel-header>
                  <mat-panel-title class="main-font">
                    <label class="image-container">
                      <img [src]="utilityService.getSanitizeUrl(result.filestorage.path)" alt="project image" class="logo imageLogo mt-3 rounded-circle">
                    </label>
                    {{ result?.alias }}
                  </mat-panel-title>
                  <mat-panel-description class="justify-content-end main-font" >
                  <span>Dal {{result?.startproject_date | date: 'dd/MM/yyyy'}} </span>

                  <span> &nbsp;{{result?.endproject_date !=  null ? 'al ' +(result?.endproject_date | date: 'dd/MM/yyyy') : '- Presente'}} </span>

                  </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="row g-5 justify-content-center mt-3">
                <ng-container *ngFor="let profile of getProfile(teamsCourses[i].project_user)">
                  <app-card-membro-team class="col-3"
                    [data]="{
                      img: profile.img,
                      fullname: profile.fullname,
                      roles: profile.roles
                    }"
                  >
                  </app-card-membro-team>
                </ng-container>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
      </mat-tab>
    </mat-tab-group> -->

    <!-- Mostra la scritta nessun risultato se un utente non ha avuto alcun team in un determinato anno -->
    <h4 class="mt-5" *ngIf="teams?.project_user?.length == 0">
      Nessun Team da mostrare
    </h4>

    <!-- paginator -->
    <!-- <mat-paginator class="mt-5" *ngIf="showPaginator" [length]="100" [pageSize]="10" [pageSizeOptions]="[10, 25, 100]" aria-label="Seleziona pagina"></mat-paginator> -->

    <!-- </div> -->
  </div>
</div>

<!-- Gif in caso di team vuoto -->
<ng-template #sadGif>
  <div class="col-10 mx-auto">
    <ng-lottie [options]="lottieConfig" (animCreated)="handleAnimation($event)">
    </ng-lottie>
  </div>
</ng-template>
